module.exports = __webpack_public_path__ + "static/media/juraya.d5361e81.webp";